import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

export const LOGO_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_2ffec7aa-046d-49e0-975a-ec7ff4399b93/artifacts/efb34a592c7fb167_IMG_6096.PNG";
export const CHANNEL_SUBSCRIBE_URL = "https://www.youtube.com/@MIZUBINI?sub_confirmation=1";

export const thumb = (id) => `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
export const fileUrl = (p) => `${process.env.REACT_APP_BACKEND_URL}/api${p}`;
export const euro = (n) => Number(n).toLocaleString("fr-FR", { style: "currency", currency: "EUR" });

export const localDate = () => {
  const d = new Date();
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

export const lyricStanzas = (lyrics) =>
  (lyrics || "")
    .trim()
    .split(/\n\s*\n/)
    .map((s) => s.split("\n").map((l) => l.trim().replace(/ ([?!:;»])/g, "\u00a0$1")).filter(Boolean))
    .filter((s) => s.length);
